import { Grid, useEventCallback } from '@mui/material';
import { memo, useEffect, useMemo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import ListAnsc from '../../../../../../shared/list-ansc';
import { ItemVM } from 'shell/view-models/item';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import FormTratxtBase from '../transcription-data/form-tratxt-base';

interface ParentTransmittedCitizenshipProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  configuration?: string;
  tipoEvento?: string;
  idEvento?: number;
  idUseCase?: string;
  controllParentTransmittedCitizenship: (parentTransmittedCitizenship?: string) => void;
}

const ParentTransmittedCitizenshipComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
  onChanges,
  configuration,
  tipoEvento,
  idEvento,
  idUseCase,
  controllParentTransmittedCitizenship,
}: ParentTransmittedCitizenshipProps): React.ReactElement => {
  const isGtrscit2 = useMemo(() => {
    return configuration === ConfigurationType.GTRSCIT2;
  }, [configuration]);

  useEffect(() => {
    controllParentTransmittedCitizenship(values?.parentTransmittedCitizenship);
  }, [values?.parentTransmittedCitizenship]);

  const handleListParentTransmittedCitizenship = useEventCallback((item?: ItemVM) => {
    onChange('parentTransmittedCitizenship', item?.id);
  });

  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={6}>
        <ListAnsc
          label="Genitore che ha trasmesso la cittadinanza"
          idDominio="88"
          value={values?.parentTransmittedCitizenship || ''}
          onChange={handleListParentTransmittedCitizenship}
          disabled={disabled}
          error={
            Boolean(errors?.parentTransmittedCitizenship) && touched?.parentTransmittedCitizenship
          }
          required
        />
      </Grid>
      {isGtrscit2 ? (
        <FormTratxtBase
          onChange={onChange}
          onChanges={onChanges}
          values={values}
          errors={errors}
          touched={touched}
          tipoEvento={tipoEvento}
          idEvento={idEvento}
          disabled={disabled}
          idUseCase={idUseCase}
        />
      ) : undefined}
    </Grid>
  );
};

ParentTransmittedCitizenshipComponent.displayName = 'Form Parent Transmitted Citizenship component';

const ParentTransmittedCitizenship = memo(ParentTransmittedCitizenshipComponent);

export default ParentTransmittedCitizenship;
